import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { getMotionEditorCreateScenePath } from '../../MotionEditor/store/sceneCreateUtils';
import { getSceneMotionEditorPath } from '../assetLibraryActions';
import type { AssetLibraryMediaSelection } from '../assetLibraryMediaSelection';
import type { MascotOpenWithSlot } from '../assetLibraryOpenWithPrefill';
import { stashAssetLibraryOpenWithPrefill } from '../assetLibraryOpenWithPrefill';

export function useAssetLibraryOpenWithActions() {
  const navigate = useNavigate();

  const openMotionEditorFromJob = useCallback(
    ({ jobId, label }: { jobId: string; label: string }) => {
      navigate(getMotionEditorCreateScenePath(jobId, label));
    },
    [navigate],
  );

  const openSceneInMotionEditor = useCallback(
    (sceneId: string) => {
      navigate(getSceneMotionEditorPath(sceneId));
    },
    [navigate],
  );

  const openComicWithVideo = useCallback(
    (selection: AssetLibraryMediaSelection) => {
      stashAssetLibraryOpenWithPrefill({ target: 'comic', selection });
      navigate('/comic');
    },
    [navigate],
  );

  const openMascotWithMedia = useCallback(
    (slot: MascotOpenWithSlot, selection: AssetLibraryMediaSelection) => {
      stashAssetLibraryOpenWithPrefill({ target: 'mascot', slot, selection });
      navigate('/mascot');
    },
    [navigate],
  );

  return {
    openMotionEditorFromJob,
    openSceneInMotionEditor,
    openComicWithVideo,
    openMascotWithMedia,
  };
}
